// import {
//   Users,
//   Mic,
//   Database,
//   TrendingUp,
//   Volume2,
//   Map,
//   Award,
//   CheckCircle2,
//   ArrowRight,
// } from "lucide-react";

// export default function AudioVoicePage() {
//   const datasets = [
//     {
//       title: "Conversational Speech",
//       samples: "500K+",
//       desc: "Natural daily conversation datasets",
//     },
//     {
//       title: "Command & Control",
//       samples: "200K+",
//       desc: "Voice command recognition training data",
//     },
//     {
//       title: "Emotional Speech",
//       samples: "150K+",
//       desc: "Speech with various emotional tones",
//     },
//     {
//       title: "Accented Speech",
//       samples: "300K+",
//       desc: "Multiple regional accent variations",
//     },
//     {
//       title: "Background Noise",
//       samples: "100K+",
//       desc: "Environmental and ambient sound profiles",
//     },
//     {
//       title: "Music & Sound FX",
//       samples: "250K+",
//       desc: "Music and effects library for training",
//     },
//   ];

//   const features = [
//     {
//       icon: Users,
//       title: "Native Speakers",
//       desc: "1000+ native speakers from 50+ countries",
//     },
//     {
//       icon: Volume2,
//       title: "High Quality Audio",
//       desc: "48kHz, 24-bit professional audio recording",
//     },
//     {
//       icon: Map,
//       title: "Regional Diversity",
//       desc: "Multiple accents and dialects coverage",
//     },
//     {
//       icon: Database,
//       title: "Metadata Rich",
//       desc: "Complete speaker info and audio characteristics",
//     },
//   ];

//   return (
//     <main style={{ backgroundColor: "#ffffff" }}>
//       {/* Hero Section - Professional */}
//       <section
//         style={{
//           background: `
//       linear-gradient(
//         rgba(0, 0, 0, 0.75),
//         rgba(0, 0, 0, 0.75)
//       ),
//       url('https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=1920&q=80')
//     `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "75px 20px", // ⬅️ reduced height (same as ecommerce)
//             color: "white",
//           }}
//         >
//           <div style={{ maxWidth: "720px" }}>
//             {/* Badge */}
//             <div
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 marginBottom: "16px",
//                 background: "rgba(59,130,246,0.14)",
//                 border: "1px solid rgba(59,130,246,0.35)",
//                 padding: "8px 14px",
//                 borderRadius: "6px",
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: "12px",
//                   fontWeight: 600,
//                   letterSpacing: "1px",
//                   color: "#93c5fd",
//                 }}
//               >
//                 ENTERPRISE AUDIO DATA SOLUTIONS
//               </span>
//             </div>

//             {/* Title */}
//             <h1
//               style={{
//                 fontSize: "44px",
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 lineHeight: "1.15",
//                 letterSpacing: "-0.4px",
//               }}
//             >
//               Professional Audio & Voice Dataset Services
//             </h1>

//             {/* Description */}
//             <p
//               style={{
//                 fontSize: "16px",
//                 maxWidth: "600px",
//                 opacity: 0.95,
//                 lineHeight: "1.55",
//                 marginBottom: "26px",
//                 color: "#cbd5e1",
//               }}
//             >
//               High-quality, ethically sourced audio and voice datasets from
//               native speakers across 50+ languages for training advanced speech
//               recognition and voice AI models.
//             </p>

//             {/* Actions */}
//             <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
//               <button
//                 style={{
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "none",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                 }}
//               >
//                 Explore Datasets <ArrowRight size={16} />
//               </button>

//               <button
//                 style={{
//                   background: "transparent",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "1.5px solid rgba(255,255,255,0.35)",
//                   cursor: "pointer",
//                 }}
//               >
//                 Request Sample
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Key Stats */}
//       <section style={{ padding: "60px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//               gap: "32px",
//             }}
//           >
//             {[
//               { value: "1000+", label: "Native Speakers" },
//               { value: "50+", label: "Languages" },
//               { value: "5M+", label: "Audio Hours" },
//               { value: "99.2%", label: "Accuracy Rate" },
//             ].map((stat, index) => (
//               <div key={index} style={{ textAlign: "center", padding: "24px" }}>
//                 <div
//                   style={{
//                     color: "#3b82f6",
//                     fontSize: "36px",
//                     fontWeight: "700",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   {stat.value}
//                 </div>
//                 <div
//                   style={{
//                     color: "#64748b",
//                     fontSize: "14px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   {stat.label}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Dataset Features
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "32px",
//             }}
//           >
//             {features.map((feature, index) => {
//               const Icon = feature.icon;
//               return (
//                 <div
//                   key={index}
//                   style={{
//                     display: "flex",
//                     gap: "20px",
//                     alignItems: "flex-start",
//                   }}
//                 >
//                   <div
//                     style={{
//                       backgroundColor: "#3b82f6",
//                       color: "white",
//                       width: "56px",
//                       height: "56px",
//                       borderRadius: "8px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Icon size={26} />
//                   </div>
//                   <div>
//                     <h3
//                       style={{
//                         fontSize: "18px",
//                         fontWeight: "700",
//                         marginBottom: "8px",
//                         color: "#1a202c",
//                       }}
//                     >
//                       {feature.title}
//                     </h3>
//                     <p
//                       style={{
//                         color: "#64748b",
//                         fontSize: "14px",
//                         lineHeight: "1.6",
//                       }}
//                     >
//                       {feature.desc}
//                     </p>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Dataset Categories */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Available Datasets
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {datasets.map((dataset, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#ffffff",
//                   border: "1px solid #e5e7eb",
//                   padding: "28px",
//                   borderRadius: "8px",
//                   boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                 }}
//               >
//                 <div
//                   style={{
//                     color: "#3b82f6",
//                     fontSize: "13px",
//                     fontWeight: "700",
//                     marginBottom: "8px",
//                     letterSpacing: "0.5px",
//                   }}
//                 >
//                   {dataset.samples}
//                 </div>
//                 <h3
//                   style={{
//                     fontSize: "20px",
//                     fontWeight: "700",
//                     marginBottom: "12px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {dataset.title}
//                 </h3>
//                 <p
//                   style={{
//                     color: "#64748b",
//                     marginBottom: "20px",
//                     fontSize: "14px",
//                     lineHeight: "1.6",
//                   }}
//                 >
//                   {dataset.desc}
//                 </p>
//                 <button
//                   style={{
//                     color: "#3b82f6",
//                     borderColor: "#3b82f6",
//                     border: "2px solid",
//                     padding: "10px 24px",
//                     borderRadius: "6px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     backgroundColor: "transparent",
//                     cursor: "pointer",
//                     width: "100%",
//                   }}
//                 >
//                   View Details
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Quality Assurance */}
//       <section style={{ backgroundColor: "#ffffff", padding: "80px 20px" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Quality Assurance Process
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//               gap: "24px",
//             }}
//           >
//             {[
//               {
//                 title: "Recording Verification",
//                 points: [
//                   "Studio quality check",
//                   "Audio level validation",
//                   "Noise floor analysis",
//                   "Speaker authentication",
//                 ],
//               },
//               {
//                 title: "Data Processing",
//                 points: [
//                   "Format normalization",
//                   "Metadata tagging",
//                   "Duplicate removal",
//                   "Batch validation",
//                 ],
//               },
//               {
//                 title: "Quality Review",
//                 points: [
//                   "Manual sampling",
//                   "Compliance check",
//                   "Documentation",
//                   "Delivery verification",
//                 ],
//               },
//             ].map((qa, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#f9fafb",
//                   padding: "28px",
//                   borderRadius: "8px",
//                   border: "1px solid #e5e7eb",
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "700",
//                     marginBottom: "20px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {qa.title}
//                 </h3>
//                 <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                   {qa.points.map((point, idx) => (
//                     <li
//                       key={idx}
//                       style={{
//                         display: "flex",
//                         gap: "12px",
//                         marginBottom: "12px",
//                         alignItems: "flex-start",
//                       }}
//                     >
//                       <CheckCircle2
//                         size={18}
//                         style={{
//                           color: "#3b82f6",
//                           flexShrink: 0,
//                           marginTop: "2px",
//                         }}
//                       />
//                       <span style={{ color: "#475569", fontSize: "14px" }}>
//                         {point}
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Use Cases */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f9fafb" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
//         >
//           <h2
//             style={{
//               fontSize: "32px",
//               fontWeight: "700",
//               textAlign: "center",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Common Use Cases
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "20px",
//             }}
//           >
//             {[
//               "Speech Recognition & ASR",
//               "Voice Authentication",
//               "Voice Assistant Training",
//               "Emotion Detection",
//               "Accent Adaptation",
//               "Noise Robustness",
//             ].map((useCase, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#ffffff",
//                   borderLeft: "3px solid #3b82f6",
//                   padding: "20px",
//                   borderRadius: "8px",
//                   boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "12px",
//                 }}
//               >
//                 <TrendingUp
//                   size={22}
//                   style={{ color: "#3b82f6", flexShrink: 0 }}
//                 />
//                 <p
//                   style={{
//                     color: "#1a202c",
//                     fontWeight: "600",
//                     fontSize: "15px",
//                     margin: 0,
//                   }}
//                 >
//                   {useCase}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA - Professional */}
//       <section
//         style={{
//           backgroundColor: "#1e293b",
//           padding: "80px 20px",
//           color: "white",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "800px",
//             margin: "0 auto",
//             textAlign: "center",
//             padding: "0 20px",
//           }}
//         >
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "700",
//               marginBottom: "16px",
//               letterSpacing: "-0.5px",
//             }}
//           >
//             Need Custom Audio & Voice Datasets?
//           </h2>
//           <p
//             style={{
//               fontSize: "16px",
//               color: "#cbd5e1",
//               marginBottom: "32px",
//               lineHeight: "1.6",
//             }}
//           >
//             Contact our team to discuss your specific requirements and receive a
//             customized dataset proposal tailored to your AI training needs.
//           </p>
//           <div
//             style={{
//               display: "flex",
//               gap: "16px",
//               justifyContent: "center",
//               flexWrap: "wrap",
//             }}
//           >
//             <button
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 backgroundColor: "#3b82f6",
//                 color: "white",
//                 padding: "14px 32px",
//                 borderRadius: "6px",
//                 fontWeight: "600",
//                 fontSize: "15px",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               Request Quote <ArrowRight size={18} />
//             </button>
//             <button
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 backgroundColor: "transparent",
//                 color: "white",
//                 padding: "14px 32px",
//                 borderRadius: "6px",
//                 fontWeight: "600",
//                 fontSize: "15px",
//                 border: "2px solid rgba(255, 255, 255, 0.2)",
//                 cursor: "pointer",
//               }}
//             >
//               View Samples
//             </button>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

import { motion } from "framer-motion";
import {
  Users,
  Mic,
  Database,
  TrendingUp,
  Volume2,
  Globe2,
  ArrowRight,
  ShieldCheck,
  Zap,
  Waves,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function AudioVoicePage() {
  const datasets = [
    {
      title: "Conversational Speech",
      desc: "Natural daily interaction datasets for ASR training.",
    },
    {
      title: "Command & Control",
      desc: "Short-form voice command recognition data.",
    },
    {
      title: "Emotional Speech",
      desc: "Speech datasets tagged with primary emotional tones.",
    },
    {
      title: "Accented Speech",
      desc: "Multi-regional accent variations and dialects.",
    },
    {
      title: "Ambient Noise",
      desc: "Environmental sound profiles for noise cancellation.",
    },
    {
      title: "Phonetic Datasets",
      desc: "Granular phonetic breakdown for TTS models.",
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://i.pinimg.com/736x/a9/b7/72/a9b7723782e7bd82b85e04728fa80382.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              AI Training Infrastructure
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">Audio & Voice</span>{" "}
              Data.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              High-fidelity, ethically sourced audio datasets from native
              speakers across 50+ languages engineered for training advanced
              speech recognition and generative AI.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Explore Datasets <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= TECHNICAL CAPABILITIES (FIXED IMAGE HEIGHT) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left Content Side */}
            <motion.div {...fadeUp} className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-slate-900 mb-6">
                  High-Fidelity Engineering
                </h2>
                <p className="text-slate-600 leading-relaxed font-light text-lg">
                  Quality in AI models is a direct reflection of the data
                  quality used in training. Our audio acquisition follows
                  rigorous studio-grade protocols to ensure maximum model
                  accuracy.
                </p>
              </div>

              <div className="grid gap-6">
                {[
                  {
                    icon: Volume2,
                    t: "Studio-Grade Recording",
                    d: "48kHz, 24-bit professional audio capture with controlled noise floors.",
                  },
                  {
                    icon: Globe2,
                    t: "Linguistic Diversity",
                    d: "Coverage across regional dialects, urban slangs, and formal accents.",
                  },
                  {
                    icon: Database,
                    t: "Rich Metadata",
                    d: "Granular tagging including speaker age, gender, device, and environment.",
                  },
                ].map((item, i) => (
                  <div key={i} className="flex gap-4">
                    <div className="shrink-0 w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center text-indigo-600">
                      <item.icon size={20} />
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-900">
                        {item.t}
                      </h4>
                      <p className="text-xs text-slate-500 mt-1 leading-relaxed">
                        {item.d}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Right Image Side (Reduced height to match content) */}
            <div className="relative">
              <div className="absolute -inset-4 bg-indigo-100/50 rounded-3xl -z-10 blur-2xl opacity-50" />
              <div className="overflow-hidden rounded-2xl shadow-2xl border border-slate-100 h-[400px] lg:h-[480px]">
                <img
                  src="https://i.pinimg.com/736x/f7/1a/f1/f71af1951759fa21f5a2642043655225.jpg"
                  alt="Voice Recording Engineering"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= DATASET CATEGORIES ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Inventory
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Available Data Categories
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {datasets.map((dataset, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 bg-white rounded-2xl border border-slate-200 hover:border-indigo-500/30 hover:shadow-xl transition-all duration-300 text-left relative overflow-hidden"
              >
                <div className="relative z-10">
                  <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                    {dataset.title}
                  </h3>
                  <p className="text-[13px] text-slate-500 leading-relaxed font-light mb-6">
                    {dataset.desc}
                  </p>
                  <a
                    href="/contact"
                    className="inline-flex items-center gap-2 text-[11px] font-bold text-slate-900 uppercase tracking-tighter hover:text-indigo-600 transition-all"
                  >
                    Spec Sheet <ArrowRight size={14} />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= DEPLOYMENT VECTORS ================= */}
      <section className="py-24 bg-white text-center">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-slate-900 tracking-tight mb-16">
            Deployment Vectors
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[
              "Speech Recognition",
              "Voice Auth",
              "Virtual Assistants",
              "Emotion AI",
              "Accent Mapping",
              "TTS Synthesis",
            ].map((useCase, i) => (
              <div
                key={i}
                className="px-4 py-6 border border-slate-100 rounded-xl bg-slate-50/50 hover:bg-white hover:shadow-md transition-all"
              >
                <Waves
                  className="mx-auto text-indigo-600 mb-3"
                  size={20}
                  strokeWidth={1.5}
                />
                <p className="text-[12px] font-bold text-slate-700 tracking-tight">
                  {useCase}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Custom Voice Acquisition.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Need a specific language or regional accent? Our native recording
            teams provide custom data collection services globally.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Consult Data Expert
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}